import styled, { css } from 'styled-components';
import { ALabelSize, type ALabelProps } from './ALabel.types';

type StyleProps = Omit<ALabelProps, 'text'>;

const stylesBySize = ({ size }: StyleProps) => {
  return size === ALabelSize.XS
    ? css`
        font-size: 0.75rem;
      `
    : css`
        font-size: 0.875rem;
      `;
};

export const ALabelWrapper = styled.span<StyleProps>`
  color: var(--t-brand-fg-color);
  font-family: var(--t-font-family);
  font-weight: 700;
  line-height: 1;
  display: inline-block;
  ${stylesBySize}

  &.m-ellipsis-1line {
    // override
    line-height: 1;
    display: inline-block;
  }
`;
